import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";

@Injectable()
export class ClientVersionService {

  public BASE = '/api';

  constructor(private http: HttpClient) {
  }

  getCurrentVersion() {
    return this.http
      .get(`${this.BASE}/webclient-version`);
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_master@2/app/Resources/Public/src/app/modules/core/services/client-version.service.ts